import { Dialog } from '@mui/material';
import { CreateGroupForm } from 'components';
import React, { ReactElement } from 'react';
import { Group, GroupType } from 'utils';
import { TransitionProps } from '@mui/material/transitions';

export interface CreateGroupModalProps {
    onGroupCreated: (group: Group) => void;
    onGroupCreatedFailed: (message: string) => void;
    groupType: GroupType;
    open?: boolean;
    onClose?: Function;
}

// No-op transition that doesn't call reflow, avoiding scrollTop errors
const NoTransition = React.forwardRef(function NoTransition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    const { children, in: inProp } = props;
    return (
        <div ref={ref as React.Ref<HTMLDivElement>} style={{ display: inProp ? 'block' : 'none' }}>
            {children}
        </div>
    );
});

export default function CreateGroupModal({
    onGroupCreated,
    onGroupCreatedFailed,
    groupType = GroupType.GROUP,
    open = true,
    onClose,
}: CreateGroupModalProps): ReactElement {
    const handleGroupCreated = (group: Group) => {
        onGroupCreated(group);
    };
    const handleGroupCreationFailed = (message: string) => {
        onGroupCreatedFailed(message);
    };
    return (
        <Dialog
            open={open}
            TransitionComponent={NoTransition}
            TransitionProps={{ timeout: 0 }}
            disableEscapeKeyDown={false}
            onClose={(event, reason) => {
                if (reason === 'backdropClick' && onClose) {
                    onClose();
                }
            }}
        >
            <CreateGroupForm
                onGroupCreationFailed={handleGroupCreationFailed}
                onGroupCreated={handleGroupCreated}
                groupType={groupType}
                onClose={onClose}
            />
        </Dialog>
    );
}
